/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Foot_IntegrationsInputs */

const en_hub_foot_integrations = /** @type {(inputs: Hub_Foot_IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrations`)
};

const id_hub_foot_integrations = /** @type {(inputs: Hub_Foot_IntegrationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrasi`)
};

/**
* | output |
* | --- |
* | "Integrations" |
*
* @param {Hub_Foot_IntegrationsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_foot_integrations = /** @type {((inputs?: Hub_Foot_IntegrationsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Foot_IntegrationsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_foot_integrations(inputs)
	return en_hub_foot_integrations(inputs)
});